import { render } from "./AnnouncementCompletedPurchasesPage.vue?vue&type=template&id=cffa4916"
import script from "./AnnouncementCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./AnnouncementCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__